import { createFileRoute } from "@tanstack/react-router";
import { AdminListingApprovalPage } from "@/components/AdminListingApproval";

export const Route = createFileRoute("/_authenticated/admin/listings/pending")({
  head: () => ({
    meta: [
      { title: "Pending Listings · Landoo Admin" },
      { name: "description", content: "Review and moderate listings awaiting approval." },
    ],
  }),
  component: () => <AdminListingApprovalPage status="pending" />,
});
